
import React from 'react';
import { FaBell, FaSearch } from "react-icons/fa";
import person from '../assets/person.png'; 

const Header = () => {
  return (
    <header className="flex justify-between items-center p-4 sticky top-0 bg-white shadow-sm z-10">
      <div className="flex items-center gap-2 border border-gray-200 rounded-lg px-3 py-1.5">
        <FaSearch className="text-gray-400" />
        <input
          type="text"
          placeholder="Search..."
          className="outline-none border-none bg-transparent text-sm"
        />
      </div>

      <div className="flex items-center gap-6">
        <div className="relative">
            <FaBell className="text-gray-600 h-5 w-5" />
            <span className="absolute -top-1 -right-1 h-3 w-3 bg-red-500 rounded-full border-2 border-white"></span>
        </div>
        <div className="flex items-center gap-3">
          <img
            src={person} 
            alt="profile"
            className="w-9 h-9 rounded-full object-cover"
          />
          <div>
            <p className="text-sm font-semibold text-gray-800"></p>
            <p className="text-xs text-gray-500"></p>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
